// manage-profile-tabs.provider.ts

import { APP_INITIALIZER, Component, NgModule } from "@angular/core";
import { TwoFactorTabComponent } from "@volo/abp.ng.account/public";
import {
  eAccountManageProfileTabNames,
  ManageProfileTabsService,
} from "@volo/abp.ng.account/public/config";
import { GalileuCredentialDetailModalComponent } from "../components/galileu-credential-detail.component";
import { GalileuCredentialDetailViewService } from "../services/galileu-credential-detail.service";

export const MANAGE_PROFILE_TAB_PROVIDER = {
  provide: APP_INITIALIZER,
  useFactory: configureManageProfileTabs,
  deps: [ManageProfileTabsService],
  multi: true,
};

export function configureManageProfileTabs(tabs: ManageProfileTabsService) {
  return () => {
    tabs.add([
      {
        name: "Acesso Galileu", 
        order: 5,
        component: GalileuCredentialDetailModalComponent,
      },
    ]);

    tabs.remove([eAccountManageProfileTabNames.AuthenticatorApp, eAccountManageProfileTabNames.TwoFactor])
  };
}
